import React from 'react';
import { Box, Button, ButtonProps } from '@mui/material';

interface DrawerFooterProps {
  primaryButton?: {
    label: string;
    onClick?: () => void;
    loading?: boolean;
    disabled?: boolean;
    type?: 'button' | 'submit';
    variant?: ButtonProps['variant'];
    color?: ButtonProps['color'];
  };
  secondaryButton?: {
    label: string;
    onClick: () => void;
    disabled?: boolean;
    variant?: ButtonProps['variant'];
  };
  children?: React.ReactNode;
}

export const DrawerFooter: React.FC<DrawerFooterProps> = ({ primaryButton, secondaryButton, children }) => {
  return (
    <Box
      sx={{
        p: 3,
        pt: 2,
        borderTop: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        position: 'sticky',
        bottom: 0,
        zIndex: 10,
      }}
    >
      {children ? (
        children
      ) : (
        <Box sx={{ display: 'flex', gap: 2 }}>
          {secondaryButton && (
            <Button
              variant={secondaryButton.variant || 'outlined'}
              onClick={secondaryButton.onClick}
              disabled={secondaryButton.disabled}
              fullWidth
              size="large"
            >
              {secondaryButton.label}
            </Button>
          )}
          {primaryButton && (
            <Button
              type={primaryButton.type || 'button'}
              variant={primaryButton.variant || 'contained'}
              color={primaryButton.color || 'primary'}
              onClick={primaryButton.onClick}
              disabled={primaryButton.disabled || primaryButton.loading}
              fullWidth
              size="large"
            >
              {primaryButton.loading ? 'Loading...' : primaryButton.label}
            </Button>
          )}
        </Box>
      )}
    </Box>
  );
};
